import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6978f9c5&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=6978f9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978f9c5",
  null
  
)

export default component.exports